export const MIN_PASSWORD_LENGTH = 8
export const MAX_FIRST_NAME_LENGTH = 50
export const MAX_LAST_NAME_LENGTH = 50
export const MAX_USER_EMAIL_LENGTH = 50
export const MAX_MOBILE_LENGTH = 50

export const isPasswordLongEnough = (password: string): boolean => password.length >= MIN_PASSWORD_LENGTH
